export const CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

function updateLocation(method) {
  return (...args) => ({
    type: CALL_HISTORY_METHOD,
    payload: { method, args },
  });
}

export const push = updateLocation('push');

export function locationChanged(location) {
  return {
    type: LOCATION_CHANGE,
    payload: location,
  };
}

export function routerMiddleware(history) {
  return () => (next) => (action) => {
    if (action.type !== CALL_HISTORY_METHOD) {
      return next(action);
    }

    const { method, args } = action.payload;
    return history[method](...args);
  };
}
